import { Anchor, Flex, Group, List, Stack, Text } from "@mantine/core";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import userLogo from "../../assets/jobSeeker.png";
import Button from "../../components/Button";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import Page from "../../components/Page";
import { userData } from "../../Helpers";
import {
  followFunction,
  initiateChatWithUser,
  unfollowFunction
} from "../../JobSeekerPages/jobSeekerHelperFunctions/jobseekerHelpers";
import { loadJobSeekerDetails } from "./loadData";
import "./styles.css";

const Index = ({}) => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  console.log("data", data);

  //get profile data
  useEffect(() => {
    loadJobSeekerDetails(id).then(setData);
  }, [id, refresh]);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <LoaderWrapper loading={loading}>
        <div className="viewProfile">
          <Flex gap={"md"} direction={"column"} style={{ width: "30%" }}>
            <div className="profile-1 shadow">
              <img
                src={data.jobSeeker?.[0]?.jobSeekerProfileImage || userLogo}
                width="35%"
                height="35%"
                className="rounded-circle"
                style={{ border: "2px solid gray" }}
                alt=""
              />
              <h4 className="text-dark mb-0"> {data.displayName}</h4>
              <p className=""> {data?.jobSeeker?.[0]?.jobTitle}</p>
              <p className="m-0">
                {" "}
                Industry:{" "}
                {(data?.jobSeeker &&
                  data?.jobSeeker?.[0]?.jobSeekerIndustry?.[0]?.industry
                    ?.industryName) ||
                  "NA"}
              </p>
              <p className=""> Location: {data.address1}</p>
              <h6 className="pref"> Preferences</h6>
              <p className="m-0">
                {" "}
                $
                {data?.jobSeeker?.[0]?.minSalary +
                  " - " +
                  data?.jobSeeker?.[0]?.maxSalary}
              </p>
              <p className="m-0">
                {" "}
                {data?.jobSeeker?.[0]?.employmentPreferences?.map(
                  (obj) => obj?.preferenceType?.lookupName
                )}
              </p>
              {/* <h6 className="pref"> Full Time, Hourly Salary, COntract</h6> */}

              <Group position="center" mt="md">
                {" "}
                <Button
                  title={"Message"}
                  fontWeight="700"
                  width="92px"
                  onClick={() => {
                    initiateChatWithUser(id);
                  }}
                />
                {data?.followingList
                  ?.map((followingList) => {
                    if (followingList.user === userData.id) {
                      return followingList.user;
                    }
                  })
                  .includes(userData.id) ? (
                  <Button
                    onClick={() => {
                      unfollowFunction(id, setLoading, refresh, setRefresh);
                    }}
                    title={"Unfollow"}
                    fontWeight="700"
                    width="100px"
                  />
                ) : (
                  <div className="d-flex justify-content-evenly">
                    <Button
                      onClick={() => {
                        followFunction(id, setLoading, refresh, setRefresh);
                      }}
                      title={"Follow"}
                      primary={true}
                      fontWeight="700"
                      width="90px"
                    />
                  </div>
                )}
              </Group>
            </div>
            {data?.jobSeeker?.[0]?.jobSeekerProfileVideo[0]?.profileVideo && (
              <div className="profile-111 shadow">
                <h5 className="text-dark text-center">User Video</h5>
                <iframe
                  className="utube"
                  src={
                    data?.jobSeeker?.[0]?.jobSeekerProfileVideo[0]?.profileVideo
                  }
                  title="video"
                  width={"100%"}
                ></iframe>
              </div>
            )}
            {/* <div className="profile-111 shadow">
              <h2>Hello</h2>
            </div> */}
          </Flex>

          <div className="profile-2">
            <div className="profile-2-2 shadow">
              <h6 className="head1">PROFILE SUMMARY</h6>
              <p className="px-3 py-1">{data?.jobSeeker?.[0]?.summary}</p>
            </div>
            <div className="profile-2-1">
              <div className="video shadow">
                <h6 className="head1">EXPERIENCE</h6>
                {data?.jobSeeker?.[0]?.jobSeekerEmploymentHistory.length ===
                0 ? (
                  <p className="px-3 py-1">No Education Details</p>
                ) : (
                  data?.jobSeeker?.[0]?.jobSeekerEmploymentHistory.map(
                    (obj) => (
                      <List ml="xl" size="md">
                        <List.Item>
                          <Stack py={3} m={0} spacing={0}>
                            <Text weight={600}>{obj?.jobTitle}</Text>
                            <Group noWrap m={0} p={0} spacing={2}>
                              <Text size={13.5}>
                                ({moment(obj?.startDate).format("YYYY")}-
                                {moment(obj?.startDate).format("YYYY")})
                              </Text>
                            </Group>
                          </Stack>
                        </List.Item>
                      </List>
                    )
                  )
                )}
              </div>

              <div className="video shadow">
                <h6 className="head1">EDUCATION</h6>
                {data?.jobSeeker?.[0]?.jobSeekerEducation.length === 0 ? (
                  <p className="px-3 py-1">No Education Details</p>
                ) : (
                  data?.jobSeeker?.[0]?.jobSeekerEducation.map((obj) => (
                    <List ml="xl" size="md">
                      <List.Item>
                        <Stack py={3} m={0} spacing={0}>
                          <Text weight={600}>{obj?.degree?.degreeName}</Text>
                          <Group noWrap m={0} p={0} spacing={2}>
                            <Text size={13.5}>{obj?.school?.lookupName}</Text>
                            <Text> | </Text>
                            <Text size={13.5}>{obj?.state?.lookupName}</Text>
                          </Group>
                        </Stack>
                      </List.Item>
                    </List>
                  ))
                )}
              </div>
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">SKILLS SET</h6>
              {data?.jobSeeker?.[0]?.jobSeekerSkills.length === 0 ? (
                <Text ml="xl" size="md" py="md">
                  No Skills Added
                </Text>
              ) : (
                <List ml="xl" size="md" py="md">
                  {data?.jobSeeker?.[0]?.jobSeekerSkills?.[0]?.skills.map(
                    (obj) => (
                      <List.Item>{obj.skills?.skillName}</List.Item>
                    )
                  )}
                </List>
              )}
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">LANGUAGES</h6>
              <div className="ml-2">
                {data?.jobSeeker?.[0]?.jobSeekerLanguages.length === 0 ? (
                  <Text ml="xl" size="md" py="md">
                    No Education Added
                  </Text>
                ) : (
                  <List ml="xl" size="md" py="md">
                    {data?.jobSeeker?.[0]?.jobSeekerLanguages?.[0]?.language.map(
                      (obj) => (
                        <List.Item>{obj.language?.lookupName}</List.Item>
                      )
                    )}
                  </List>
                )}
              </div>
            </div>

            <div className="profile-2-1">
              <div className="ints shadow">
                <h6 className="head1">Interests</h6>
                {data?.jobSeeker?.[0]?.jobSeekerInterets.length === 0 ? (
                  <Text ml="xl" size="md" py="md">
                    No Interests Added
                  </Text>
                ) : (
                  <List ml="xl" size="md" py="md">
                    {data?.jobSeeker?.[0]?.jobSeekerInterets?.[0]?.interest.map(
                      (obj, index) => (
                        <List.Item>{obj.interest?.interestName}</List.Item>
                      )
                    )}
                  </List>
                )}
              </div>
              <div className="awards shadow">
                <h6 className="head1">Awards</h6>
                <p className="px-3 py-1"></p>
              </div>
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">DOCUMENTS</h6>
              <div className="ml-2">
                {data?.jobSeeker?.[0]?.jobSeekerDocuments.length === 0 ? (
                  <Text ml="xl" size="md" py="md">
                    No Documents Added
                  </Text>
                ) : (
                  <Group>
                    <List ml="xl" size="md" py="md">
                      {data?.jobSeeker?.[0]?.jobSeekerDocuments?.map((obj) => (
                        <List.Item>
                          <Anchor href={obj?.document} target="_blank">
                            {obj?.documentType?.lookupName}
                          </Anchor>
                        </List.Item>
                      ))}
                    </List>
                  </Group>
                )}
              </div>
            </div>
          </div>
        </div>
      </LoaderWrapper>
    </Page>
  );
};

export default withTranslation()(Index);
